import React, { useState, useEffect } from "react";
import api from "../services/api";
import Translator, { __ } from "services/Translator";
import HomeBannerSingle from "elements/HomeBannerSingle";
import Faqs from "../components/Faqs";
export default function LoyaltyProgram(props) {
  const user = {
    name: "Eddy Mendez",
    tier: "Gold I",
    progress: 54,
    wins: 18,
    total: 54,
    additionalInfo: "789/849",
    nextTier: "Platinum V",
    remaining: 6886,
  };
  const tierDetails = {
    tier: "Bronze I",
    badgeColor: "#CD7F32", // Bronze color
    features: [
      "Recurring & billing",
      "Recurring & billing",
      "Special Rewards",
      "Special Rewards",
      "Special Rewards",
    ],
  };
  return (
    <>
      <div className="container-xxl">
        {/* <HomeBannerSingle {...props} /> */}
        <div className="loyaltyProgram">
          <div className="loyalty-content">
            {props.isAuthenticated && (
              <div className="tracker-container">
                <div className="tracker-content">
                  <div className="tracker-header">
                    <div className="tier-badge">
                      <img
                        alt=""
                        src={require("assets/winnabull/images/loyalty-programs/gold-icon.png")}
                      />
                    </div>
                    <div className="tire-text">
                      <h3>Gold is your current tier</h3>
                      <p className="tracker-subtext">
                        Your progress is an accumulated sum through your wins.
                        Increase through tiers to earn bigger rewards.
                      </p>
                    </div>
                  </div>

                  <div className="user-details">
                    <h3>{user.name}</h3>
                    <p>{`${user.wins} Wins / ${user.total}`}</p>
                  </div>
                  <div className="progress-bar-container">
                    <div
                      className="progress-bar"
                      style={{ width: `${user.progress}%` }}
                    ></div>
                  </div>
                  <div className="progress-details">
                    <div className="from-data">
                      <img
                        alt=""
                        src={require("assets/winnabull/images/loyalty-programs/gold-icon.png")}
                      />
                      <p>{`${user.remaining} / ${user.nextTier}`}</p>
                    </div>
                    <div className="to-data">
                      <p>{`${user.remaining} / ${user.nextTier}`}</p>
                      <img
                        alt=""
                        src={require("assets/winnabull/images/loyalty-programs/platinum-icon.png")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="vip-items">
              <div className="single-vip-item">
                <div className="left-side">
                  <img
                    alt=""
                    src={require("assets/winnabull/images/loyalty-programs/bronze-icon.png")}
                  />
                </div>
                <div className="right-side">
                  <div className="tire-heading">Bronze I</div>
                  <ul>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                  </ul>
                </div>
              </div>
              <div className="single-vip-item">
                <div className="left-side">
                  <img
                    alt=""
                    src={require("assets/winnabull/images/loyalty-programs/silver-icon.png")}
                  />
                </div>
                <div className="right-side">
                  <div className="tire-heading">Silver II</div>
                  <ul>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                  </ul>
                </div>
              </div>
              <div className="single-vip-item">
                <div className="left-side">
                  <img
                    alt=""
                    src={require("assets/winnabull/images/loyalty-programs/gold-icon.png")}
                  />
                </div>
                <div className="right-side">
                  <div className="tire-heading">Gold II</div>
                  <ul>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                  </ul>
                </div>
              </div>
              <div className="single-vip-item">
                <div className="left-side">
                  <img
                    alt=""
                    src={require("assets/winnabull/images/loyalty-programs/platinum-icon.png")}
                  />
                </div>
                <div className="right-side">
                  <div className="tire-heading">Platinum II</div>
                  <ul>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                  </ul>
                </div>
              </div>
              <div className="single-vip-item">
                <div className="left-side">
                  <img
                    alt=""
                    src={require("assets/winnabull/images/loyalty-programs/diamond-icon.png")}
                  />
                </div>
                <div className="right-side">
                  <div className="tire-heading">Diamond II</div>
                  <ul>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                    <li>
                      <svg
                        width="14"
                        height="10"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 1L4.75 9.25L1 5.5"
                          stroke="white"
                          stroke-opacity="0.6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Recurring & billing
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <Faqs heading={true} {...props} />
      </div>
    </>
  );
}
